module.exports = __webpack_public_path__ + "img/shadow-landscape.ba0d72d.png";